import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Delete } from "@mui/icons-material";
import { ELIMINAR_CONTACTO } from "../graphql/mutations";
import { MainContext } from "../../../../../Context/MainCtx";
import { useMutation } from "@apollo/client";
import { CircularProgress } from "@mui/material";
import { ContactosContext } from "../Context/ContactoContext";

export default function EliminarContacto({ data }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { snackMessage } = React.useContext(MainContext);
  const { queryRefetch } = React.useContext(ContactosContext);
  const [eliminarContacto] = useMutation(ELIMINAR_CONTACTO);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteContacto = async () => {
    try {
      handleClose();
      setLoading(true);
      const res = await eliminarContacto({
        variables: {
          idContacto: data._id,
        },
      });
      snackMessage({
        message: res.data.eliminarContacto.message,
        variant: "success",
      });
      queryRefetch();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        color="warning"
        size="small"
        disableElevation
        sx={{textTransform: "none"}}
        onClick={() => handleClickOpen()}
        startIcon={
          loading ? <CircularProgress size={20} color="inherit" /> : <Delete />
        }
      >
        Eliminar
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{`Eliminar ${data.nombre}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Se va a eliminar este elemento, ¿Quiere continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus color="inherit">
            No, cancelar
          </Button>
          <Button
            onClick={() => handleDeleteContacto()}
            color="error"
            variant="contained"
            disableElevation
          >
            Si, eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
